import { IPagination } from '../types/pagination'
import { IDirectCost } from '../views/project/types/directAndPassTroughCosts'
import { IProjectCurrentDirectCosts, IProjectCurrentTasks } from '../views/project/types/project'
import { IProjectActivity } from '../views/project/types/projectActivity'
import { ITimeTracking, ITimeTrackingChart, ITimeTrackingDonutChart, ITimeTrackingInvolvedTaskFilter, ITimeTrackingInvolvedTasks } from '../views/time-tracking/types/timeTracking'
import { HttpClient } from './service'
import Urls from './urls'
import { AxiosResponse } from 'axios'


export const TimeTrackingApi = {
  getTimeTrackingEntries(queryParams?: Record<string, string>): Promise<ITimeTracking[]> {
    return HttpClient.get<ITimeTracking[], Record<string, string>>(Urls.TimeTracking.timeTracking, queryParams)
  },

  createTimeTrackingEntry(entry: ITimeTracking): Promise<ITimeTracking> {
    return HttpClient.post<ITimeTracking, ITimeTracking>(Urls.TimeTracking.timeTracking, entry)
  },

  updateTimeTrackingEntry(entry: ITimeTracking): Promise<ITimeTracking> {
    return HttpClient.put<ITimeTracking, ITimeTracking>(Urls.TimeTracking.timeTracking, entry.id, entry)
  },

  deleteTimeTrackingEntry(entry: ITimeTracking): Promise<ITimeTracking> {
    return HttpClient.delete<ITimeTracking, ITimeTracking>(Urls.TimeTracking.timeTracking, entry.id)
  },

  getTimeTrackingInvolvedTasks(queryParam: ITimeTrackingInvolvedTaskFilter): Promise<ITimeTrackingInvolvedTasks[]> {
    return HttpClient.get<ITimeTrackingInvolvedTasks[], ITimeTrackingInvolvedTaskFilter>(Urls.TimeTracking.activitiesTracking, queryParam)
  },

  getPaginatedTimeTrackingInvolvedTasks(queryParam: Record<string, string>): Promise<IPagination<ITimeTrackingInvolvedTasks[]>> {
    return HttpClient.get<IPagination<ITimeTrackingInvolvedTasks[]>, Record<string, string>>(Urls.TimeTracking.activitiesTracking, queryParam)
  },

  getTimeTrackingChartData(queryParams?: Record<string, string>): Promise<ITimeTrackingChart> {
    return HttpClient.get<ITimeTrackingChart, Record<string, string>>(`${Urls.TimeTracking.timeTracking}chart/`, queryParams)
  },

  getTimeTrackingChartDonutData(queryParams?: Record<string, string>): Promise<ITimeTrackingDonutChart> {
    return HttpClient.get<ITimeTrackingDonutChart, Record<string, string>>(`${Urls.TimeTracking.timeTracking}chart/`, queryParams)
  },

  getCurrentTasks(queryParams?: Record<string, string>): Promise<IProjectCurrentTasks | IProjectCurrentDirectCosts> {
    return HttpClient.get<IProjectCurrentTasks | IProjectCurrentDirectCosts, Record<string, string>>(Urls.TimeTracking.currentTasksTracking, queryParams)
  },

  getPaginatedCurrentTasks(queryParams?: Record<string, string>): Promise<IPagination<IProjectActivity[]>> {
    return HttpClient.get<IPagination<IProjectActivity[]>, Record<string, string>>(Urls.TimeTracking.currentTasksTracking, queryParams)
  },

  getPaginatedCurrentDirectCosts(queryParams?: Record<string, string>): Promise<IPagination<IDirectCost[]>> {
    return HttpClient.get<IPagination<IDirectCost[]>, Record<string, string>>(Urls.TimeTracking.currentTasksTracking, queryParams)
  },

  getProjectTimeTracking(projectId: number | string, queryParams?: Record<string, string | boolean>): Promise<ITimeTracking[] | IPagination<ITimeTracking[]>> {
    return HttpClient.get<ITimeTracking[] | IPagination<ITimeTracking[]>, Record<string, string | boolean>>(`${Urls.TimeTracking.timeTracking}${projectId}/project-tracking/`, queryParams)
  },

  /* Export */
  exportEmployeeTimesheetCSV(queryParams?: Record<string, string | boolean | number>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string | boolean | number>>(`${Urls.TimeTracking.timeTracking}timesheet/export`, queryParams)
  },

  exportProjectTimeSheet(queryParams?: Record<string, string | boolean | number>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string | boolean | number>>(`${Urls.TimeTracking.timeTracking}project-tracking/export`, queryParams)
  },

  /* Admin */
  getAdminTimeTrackingEntries(queryParams: Record<string, string>): Promise<ITimeTracking[]> {
    return HttpClient.get<ITimeTracking[], Record<string, string>>(`${Urls.TimeTracking.timeTracking}admin/`, queryParams)
  },

  createAdminTimeTrackingEntry(entry: ITimeTracking, employeeId: string | number): Promise<ITimeTracking> {
    return HttpClient.post<ITimeTracking, ITimeTracking>(`${Urls.TimeTracking.timeTracking}${employeeId}/admin/`, entry)
  },

  updateAdminTimeTrackingEntry(entry: ITimeTracking): Promise<ITimeTracking> {
    return HttpClient.put<ITimeTracking, ITimeTracking>(`${Urls.TimeTracking.timeTracking}${entry.id}/admin/`, null, entry)
  },

}
